import { useSelector } from 'react-redux';
import * as AIChatService from 'services/ai/chat';

export const useAIChatService = () => {
  const { token } = useSelector((store) => store.user_data);

  const sendChat = async (options = {}) => {
    const { payload } = await AIChatService.chat({ ...options, token });
    return payload;
  };

  return { sendChat };
};
